import { getNetworkList, getCipNetworkList, getMealNetworkList } from 'services';
import { getUrlParam, isEmpty } from '@/utils';
const networkApis = {
  cip: getCipNetworkList,
  meal: getMealNetworkList,
};

const handleList = {
  cip: (res) => {
    if (isEmpty(res)) return {};
    const keys = Object.keys(res);
    const data = {};
    keys.forEach((el) => {
      data[el] = res[el].list;
    });
    return data;
  },
};

export default {
  namespace: 'search',
  state: {
    tabs: [],
    listData: {},
    allData: [],
    searchData: [],
    selectTab: 'jn', // 选择的tab
  },
  effects: {
    *queryNetworkList({ payload }, { call, put }) {
      try {
        const { netwrokType } = payload || {};
        delete payload.netwrokType;
        const api = networkApis[netwrokType] || getNetworkList;
        const response = yield call(api, payload);
        const { state, data } = response.data;
        if (state === '11') {
          const getTypeDataFn = handleList[netwrokType];
          const list = getTypeDataFn ? getTypeDataFn(data) : data;
          // 根据url参数隐藏某境内,境外,高铁等
          const hideTypes = decodeURIComponent(getUrlParam('hideType') || '');
          if (hideTypes) {
            const hideTypeArr = hideTypes.split('|');
            hideTypeArr.map((el) => {
              list[el] = [];
            });
          }
          if (!list.jn) list.jn = [];
          if (!list.jw) list.jw = [];
          if (!list.gt) list.gt = [];
          const listKeys = Object.keys(list); // 列表的kyes jn jw gt
          const result = {}; // 最终结果
          const tabs = []; // 导航栏
          // 数据改造，最终效果是 jn={keys:[字母列表],data:[A:{}]],name:tab名曾}
          listKeys.forEach((el) => {
            result[el] = {};
            const resList = {};
            const lis = list[el].list || list[el] || {};
            const keyList = [];
            const hasList = lis.length !== 0;
            if (!hasList) return;
            tabs.push({
              key: el,
            });
            lis.forEach((li) => {
              // 兼容之前数据，之前sort和name，id是放在enTrafficsite里面的
              if (li.enTrafficsite) {
                const { name, id, sort } = li.enTrafficsite;
                li.enId = id;
                li.enName = name;
              }
              const sort = li.sort;
              // 当前排序是否包含在data
              const has = resList[sort];
              const hasKey = keyList.includes(sort);
              if (!hasKey) keyList.push(sort);
              if (has) {
                resList[sort].push(li);
              } else {
                resList[sort] = [li];
              }
            });
            result[el].list = resList;
            result[el].keys = keyList.sort();
            result[el].key = el;
          });
          // 全部数据，用于筛选
          const { jn = [], jw = [], gt = [] } = list;
          const allData = jn.concat(jw).concat(gt);
          allData.map((item) => {
            const newItem = item;
            newItem.enName = item.enTrafficsite && item.enTrafficsite.name.toUpperCase();
            return newItem;
          });
          let selectTab = 'jn';
          const hasJnList = list.jn.length !== 0;
          const hasJwList = list.jw.length !== 0;
          const hasGtList = list.gt.length !== 0;
          // 如果境内没有网点，境外或者高铁有，默认境外，此次高铁
          if (!hasJnList && (hasJwList || hasGtList)) {
            hasGtList && (selectTab = 'gt');
            hasJwList && (selectTab = 'jw');
          }
          yield put({
            type: 'setData',
            payload: {
              listData: result,
              allData,
              selectTab,
              tabs,
            },
          });
        } else {
          throw new Error(response.data.note);
        }
      } catch (error) {
        console.log('获取网点列表报错——--', error);
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
